import api from './api-v1';

// Create new champ type
export const createChampType = async (data) => {
  try {
    const response = await api.post('/types', data);
    return response.data;	
  } catch (error) {
    console.error('Error creating champ type:', error);
    throw error;
  }
};

// Get all champ types
export const getChampTypes = async () => {
  try {
    const response = await api.get('/types');
    return response.data;
  } catch (error) {
    console.error('Error fetching champ types:', error);
    throw error;
  }
};

// Get champ type by id
export const getChampTypeID = async (id) => {
  try {
    const response = await api.get(`/types/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching champ type:', error);
    throw error;
  }
};

// Update champ type by id
export const updateChampType = async (id, data) => {
  try {
    const response = await api.put(`/types/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating champ type:', error);
    throw error;
  }
};

// Delete champ type by id
export const deleteChampType = async (id) => {
  try {
    const response = await api.delete(`/types/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting champ type:', error);
    throw error;
  }
};